import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import {
    BULK_MESSAGE_CHOOSE_MODE,
    BULK_MESSAGE_LINKEDIN_MODE,
    BULK_MESSAGE_EMAIL_MODE,
    BULK_MESSAGE_LINKEDIN_INMAIL_MODE,
} from './mode';
import logger from '../../shared/logger';
import './style.scss';

export const MESSAGE_TYPE_LINKEDIN = 'linkedin';
export const MESSAGE_TYPE_EMAIL = 'email';
export const MESSAGE_TYPE_LINKEDIN_INMAIL = 'linkedin inmail';

const messageTypesByBulkMode = {
    [BULK_MESSAGE_LINKEDIN_MODE]: MESSAGE_TYPE_LINKEDIN,
    [BULK_MESSAGE_EMAIL_MODE]: MESSAGE_TYPE_EMAIL,
    [BULK_MESSAGE_LINKEDIN_INMAIL_MODE]: MESSAGE_TYPE_LINKEDIN_INMAIL,
};

export class BulkMessage {
    selectedMode = BULK_MESSAGE_CHOOSE_MODE;

    /* @ngInject */
    constructor($timeout, RecruiterService, ContactCandidateService, EmployerRepService) {
        this.$timeout = $timeout;
        this.RecruiterService = RecruiterService;
        this.ContactCandidateService = ContactCandidateService;
        this.EmployerRepService = EmployerRepService;
    }

    async $onInit() {
        const recruiter = await this.getRecruiter();

        this.$timeout(() => {
            this.recruiter = recruiter;
        });
    }

    async onChooseMode(mode) {
        const employerRep = await this.getEmployerRep(mode);

        this.$timeout(() => {
            this.employerRep = employerRep;
            this.selectedMode = mode;
        });
    }

    async getRecruiter() {
        const {
            RecruiterService,
            recruiterId,
        } = this;

        try {
            const { result: recruiter } = await RecruiterService.getRecruiter(recruiterId);

            return recruiter;
        } catch (error) {
            logger.error(error);
        }

        return null;
    }

    async getEmployerRep(bulkChannelMode) {
        const channel = messageTypesByBulkMode[bulkChannelMode];

        if (!channel) {
            return null;
        }

        const {
            ContactCandidateService,
            EmployerRepService,
            position,
        } = this;

        const { campaign } = await ContactCandidateService.getContactCampaignDetails({
            channel,
            undefined,
            positionId: position._id,
        });

        const employerRepId = _.get(campaign, 'senderUser.employerRepId');

        const { result: employerRep } = employerRepId
            ? await EmployerRepService.getExistingEmployerRep(employerRepId)
            : { result: null };

        return employerRep;
    }
}

export const bulkMessageConfiguration = {
    template,
    bindings: {
        candidates: '<',
        recruiterId: '<',
        position: '<',
        onClose: '&',
        onDone: '&',
        onSendMessage: '&',
        onSendEmail: '&',
        onSendLinkedinInmail: '&',
        channel: '<',
    },
    controller: BulkMessage,
    controllerAs: 'bulkMessageCtrl',
};

angular.module('TALENYA-FE').component('bulkMessage', bulkMessageConfiguration);
